module.exports = __webpack_public_path__ + "img/IchLiebeDich.39137f5a.jpg";